import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const GENETICMATERIALGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.GeneticMaterialGroup.Name')
    .required()
    .minLength(1)
    .maxLength(200)
    .build(),
  FieldBuilder
    .text('code', 'Entity.GeneticMaterialGroup.Code')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
];

export const GENETICMATERIALGROUP_CONFIG = {
  entityName: 'GeneticMaterialGroup',
  localizationKey: 'General::Entity.GeneticMaterialGroup',
  fields: GENETICMATERIALGROUP_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.GeneticMaterialGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
